<dx-form [formData]="tpvSettings" class="form last plain-styled-form" labelMode="floating" [readOnly]="formIsReadOnly">
  <dxi-item itemType="tabbed">
    <dxo-tab-panel-options [showNavButtons]="true" stylingMode="secondary" tabsPosition="left"></dxo-tab-panel-options>

    <dxi-tab title="Saisie" [colCount]="2">
      <dxi-item dataField="clientParDefautId" [label]="{text: 'Client par défaut'}" [colSpan]="colSpan"
        editorType="dxSelectBox"
        [editorOptions]="{
          dataSource: partenaireDataSource,
          displayExpr: partenaireEtTypesDisplayExpr,
          searchEnabled: true,
          valueExpr: 'id',
          showClearButton: true,
          searchExpr: ['intitule', 'codeBo'],
          showDataBeforeSearch: true
        }"
      ></dxi-item>

      <dxi-item dataField="cumulScanSurUnArticle" [label]="{text: 'Cumul des scans sur un article'}"
        editorType="dxSelectBox"
        [editorOptions]="{
          dataSource: cumulScanSurUnArticleDataSource,
          valueExpr: 'id',
          displayExpr: 'intitule',
          showClearButton: true
        }"
      ></dxi-item>

      <dxi-item dataField="typeRemiseParDefautId" [label]="{text: 'Type de remise par défaut'}"
        editorType="dxSelectBox"
        [editorOptions]="{
          dataSource: typeRemises,
          valueExpr: 'id',
          displayExpr: 'intitule',
          showClearButton: true
        }"
      ></dxi-item>

      <dxi-item dataField="dureeAvertissementExpirationCarte" [label]="{text: 'Durée avertissement expiration carte (en jours)'}" [colSpan]="colSpan"
        editorType="dxNumberBox" [editorOptions]="{ format: { type: 'fixedPoint', precision: 0 } }"
      ></dxi-item>

      <dxi-item dataField="isCalculPrixUnitaireMultiTaxes" [label]="{visible: false}" [colSpan]="colSpan"
        editorType="dxCheckBox" [editorOptions]="{ text: 'Conversion HT/TTC multi taxe', enableThreeStateBehavior: true }"
      ></dxi-item>

      <dxi-item dataField="saisieVendeur" [label]="{visible: false}" [colSpan]="colSpan"
        editorType="dxCheckBox" [editorOptions]="{ text: 'Saisie vendeur', enableThreeStateBehavior: true }"
      ></dxi-item>

      <dxi-item dataField="saisieObligVendeur" [label]="{visible: false}" [colSpan]="colSpan"
        editorType="dxCheckBox" [editorOptions]="{ text: 'Saisie vendeur obligatoire', enableThreeStateBehavior: true }"
      ></dxi-item>

      <dxi-item dataField="permettreVarianteSaisieTextuelle" [label]="{visible: false}" [colSpan]="colSpan"
        editorType="dxCheckBox" [editorOptions]="{ text: 'Permettre la saisie textuelle des variantes', enableThreeStateBehavior: true }"
      ></dxi-item>

      <dxi-item dataField="terminerSurTicketOuFacture" [label]="{visible: false}" [colSpan]="colSpan"
        editorType="dxCheckBox" [editorOptions]="{ text: 'Terminer sur ticket ou facture', enableThreeStateBehavior: true }"
      ></dxi-item>

      <dxi-item dataField="messageAccueil" colSpan="2" [label]="{text: 'Message d\'accueil'}" editorType="dxTextArea" [editorOptions]="{height: 80}"></dxi-item>

      <!-- #region Conditions de sélection obligatoire de client -->
      <dxi-item itemType="group" [caption]="'Conditions de sélection obligatoire de client'" [visible]="siteId == null">

        <dxi-item dataField="selectionObligatoireClientSettings.informationSuiviSAV" [label]="{visible: false}" [colSpan]="colSpan"
          editorType="dxCheckBox" [editorOptions]="{ text: 'Information suivi SAV', enableThreeStateBehavior: true }"
        />

        <dxi-item dataField="selectionObligatoireClientSettings.informationGarantie" [label]="{visible: false}" [colSpan]="colSpan"
          editorType="dxCheckBox" [editorOptions]="{ text: 'Information garantie', enableThreeStateBehavior: true }"
        />

        <!-- Types de mouvement -->
        <dxi-item >
          <div *dxTemplate>
            <dx-tag-box
            label="Types de mouvement"
            [items]="typesMouvementDataSource"
            valueExpr="codeBo"
            [(value)]="this.tpvSettings.selectionObligatoireClientSettings.mouvementTypeCodeBoList"
            [searchEnabled]="true"
            [showSelectionControls]="true"
            [searchExpr]="['codeBo']"
            [readOnly]="formIsReadOnly"
            [displayExpr]="partenaireEtTypesDisplayExpr"
            placeholder="Sélectionnez un type de mouvement"
            />
          </div>
        </dxi-item>

        <!-- Classifications -->
        <dxi-item >
          <div *dxTemplate>
            <dx-tag-box
            label="Classification articles"
            [items]="classificationsValuesDataSource"
            valueExpr="codeBo"
            [(value)]="this.tpvSettings.selectionObligatoireClientSettings.classificationCodeBoList"
            [searchEnabled]="true"
            [showSelectionControls]="true"
            [searchExpr]="['codeBo', 'intitule']"
            [readOnly]="formIsReadOnly"
            [displayExpr]="partenaireEtTypesDisplayExpr"
            placeholder="Sélectionnez un type de classification"
            />
          </div>
        </dxi-item>
      </dxi-item>
      <!-- #endregion -->

      <dxi-item itemType="group" [caption]="'Recherche partenaires'" [visible]="(siteId == null)">
        <dxi-item >
          <div *dxTemplate>
            <dx-tag-box
              label="Profils partenaires"
              [items]="profilsPartenairesDataSource"
              valueExpr="id"
              [(value)]="this.tpvSettings.rechercheClientProfilsAutorisesId"
              [searchEnabled]="true"
              [showSelectionControls]="true"
              [searchExpr]="['intitule']"
              [readOnly]="formIsReadOnly"
              displayExpr="intitule"
              placeholder="Sélectionnez les profils partenaires à rechercher"
            />
          </div>
        </dxi-item>

        <dxi-item dataField="exclureRechercheClientAnonyme" [label]="{visible: false}" [colSpan]="colSpan"
          editorType="dxCheckBox" [editorOptions]="{ text: 'Exclure les clients anonymes', enableThreeStateBehavior: false}"
        />
      </dxi-item>
    </dxi-tab>

    <dxi-tab title="Gestion des fonds">
      <dxi-item dataField="optionPrelevementClotureCaisse" [label]="{ text: 'Prélèvement automatique à la clôture' }" [colSpan]="colSpan"
        editorType="dxSelectBox"
        [editorOptions]="{
          text: ' ',
          dataSource: optionPrelevementClotureCaisseDataSource,
          valueExpr: 'id',
          displayExpr: 'intitule',
          showClearButton: true
        }"
      ></dxi-item>

      <dxi-item dataField="fondReference" editorType="dxNumberBox" [label]="{ text: 'Fond de référence ' }"
        [editorOptions]="{text: ' '}" hint="Montant à atteindre par le prélèvement automatique effectué à la clôture"
        [colSpan]="colSpan"
      ></dxi-item>

      <dxi-item dataField="destinationPrelevementParDefautId" editorType="dxSelectBox"
        [label]="{ text: 'Destinaton des prélèvements par default' }" [editorOptions]="{
          text: '',
          dataSource: lieuStockageDataSource,
          valueExpr: 'id',
          displayExpr: 'intitule',
          showClearButton: true
        }" [colSpan]="colSpan"
      ></dxi-item>

      <dxi-item dataField="controleObligatoireOuverture" editorType="dxCheckBox" [label]="{visible: false}"
        [editorOptions]="{
          text: 'Contrôle obligatoire à l\'ouverture',
          enableThreeStateBehavior: true
        }"
        [colSpan]="colSpan"
      ></dxi-item>

      <dxi-item dataField="controleObligatoireFermeture" editorType="dxCheckBox" [label]="{visible: false}"
        [editorOptions]="{
          text: 'Contrôle obligatoire à la fermeture',
          enableThreeStateBehavior: true
        }"
        [colSpan]="colSpan"
      ></dxi-item>

      <dxi-item dataField="isLieuStockageApportPrelevementObligatoire" editorType="dxCheckBox"
        [label]="{visible: false}"
        [editorOptions]="{
          text: 'Stockage source/destination obligatoire pour les prélèvements/apports.',
          enableThreeStateBehavior: true
        }"
        [colSpan]="colSpan"
      ></dxi-item>
    </dxi-tab>

    <dxi-tab title="Stock">
      <dxi-item dataField="utilisationEntrepotPreferentiel" editorType="dxCheckBox" [label]="{visible: false}"
        [editorOptions]="{
          text: 'Utilisation entrepot préférentiel',
          enableThreeStateBehavior: true
        }" [colSpan]="colSpan"
      ></dxi-item>

      <dxi-item dataField="multiEntrepotEnabled" editorType="dxCheckBox" [label]="{visible: false}"
        [editorOptions]="{
          text: 'Activation multi-entrepôts',
          enableThreeStateBehavior: true
        }" [colSpan]="colSpan"
      ></dxi-item>

      <dxi-item dataField="isInventaireObligatoireAvantCloture" [label]="{visible: false}" [colSpan]="colSpan"
        editorType="dxCheckBox"
        [editorOptions]="{
          text: 'Forcer l\'inventaire à la clôture.',
          enableThreeStateBehavior: true
        }"
      ></dxi-item>

      <dxi-item dataField="forcerVerificationStockAvantAjoutArticle" [label]="{visible: false}" [colSpan]="colSpan"
        editorType="dxCheckBox"
        [editorOptions]="{
          text: 'Forcer vérification du stock à l\'ajout d\'article',
          enableThreeStateBehavior: true
        }"
      ></dxi-item>

      <dxi-item dataField="bloquerVenteSiCaisseHorsConnexionEtVerificationStockForcee" [label]="{visible: false}" [colSpan]="colSpan"
        editorType="dxCheckBox"
        [editorOptions]="{
          text: 'Bloquer vente si caisse hors connexion et vérification du stock forcée',
          enableThreeStateBehavior: true
        }"
      ></dxi-item>
    </dxi-tab>

    <dxi-tab title="Sécurité" [colCount]="2">
      <dxi-item itemType="group">
        <dxi-item dataField="authentificationType" [label]="{text: 'Type d\'authentification'}" [colSpan]="colSpan"
          editorType="dxSelectBox"
          [editorOptions]="{
            dataSource: caisseTypeAuthentification,
            searchEnabled: true,
            displayExpr: 'intitule',
            valueExpr: 'id',
            showClearButton: true,
            searchExpr: ['intitule', 'codeBo'],
            showDataBeforeSearch: true
          }"
        ></dxi-item>

        <dxi-item dataField="authentificationDomain" [label]="{text: 'Domaine d\'authentification'}"
          [colSpan]="colSpan"
        ></dxi-item>

        <dxi-item dataField="elevationPrivilegeAuthentificationType"
          [label]="{text: 'Type d\'authentification pour l\'élévation de privilège'}" [colSpan]="colSpan"
          editorType="dxSelectBox"
          [editorOptions]="{
            dataSource: elevationPrivilegeAuthentificationType,
            searchEnabled: true,
            displayExpr: 'intitule',
            valueExpr: 'id',
            showClearButton: true,
            searchExpr: ['intitule', 'codeBo'],
            showDataBeforeSearch: true
          }"
        ></dxi-item>
      </dxi-item>

      <dxi-item itemType="group">
        <dxi-item dataField="identificationAvantVente" [label]="{visible: false}"
          editorType="dxCheckBox"
          [editorOptions]="{
            text: 'Identification avant vente',
            enableThreeStateBehavior: true
          }" [colSpan]="colSpan"
        ></dxi-item>

        <dxi-item dataField="verrouillageApresVente" [label]="{visible: false}" [colSpan]="colSpan"
          editorType="dxCheckBox"
          [editorOptions]="{
            text: 'Verrouillage après une vente',
            enableThreeStateBehavior: true
          }"
        ></dxi-item>

        <dxi-item dataField="multiCaissier" [label]="{visible: false}" [colSpan]="colSpan"
          editorType="dxCheckBox"
          [editorOptions]="{
            text: 'Activation multi-caissier',
            enableThreeStateBehavior: true
          }"
        ></dxi-item>

        <dxi-item dataField="pieceRechercheAvancee" [label]="{visible: false}" [colSpan]="colSpan"
          editorType="dxCheckBox"
          [editorOptions]="{
            text: 'Panneau de recherche avancée de pièce',
            enableThreeStateBehavior: true
          }"
        ></dxi-item>

        <dxi-item dataField="isBPProcurationReexpeditionVisible" [visible]="isNiuora" [label]="{visible: false}" [colSpan]="colSpan"
          editorType="dxCheckBox"
          [editorOptions]="{
            text: 'Afficher les fonctionnalités des boîtes postales, procurations et réexpéditions',
            enableThreeStateBehavior: true
          }"
        ></dxi-item>

        <dxi-item  dataField="activerCarteClient" [label]="{visible: false}" [colSpan]="colSpan"
          editorType="dxCheckBox"
          [editorOptions]="{
            text: 'Activer la carte client',
            enableThreeStateBehavior: true,
            elementAttr: { id: 'activerCarteClient' }
          }"
        ></dxi-item>
      </dxi-item>
    </dxi-tab>

    <dxi-tab title="Matériel" [colCount]="4">
      <dxi-item dataField="lienTpe" [colSpan]="1" [label]="{visible: false}"
        editorType="dxCheckBox"
        [editorOptions]="{ text: 'Lien TPE', enableThreeStateBehavior: true }"
      ></dxi-item>

      <dxi-item dataField="versionCibleMiseAJour" editorType="dxSelectBox" [editorOptions]="versionsTpvOptions"  [colSpan]="1" [label]="{text: 'Version pour mise à jour'}"></dxi-item>
      <dxi-item dataField="cleLicenceWacomSignature" [colSpan]="2" [label]="{text: 'Clé d\'utilisation WACOM'}"></dxi-item>
    </dxi-tab>

    <dxi-tab title="Fret armateur">
      <dxi-item dataField="activerModeFret" [label]="{text:'Activer mode fret'}" editorType="dxSwitch"></dxi-item>
    </dxi-tab>
  </dxi-item>
</dx-form>

<dx-popover target="#activerCarteClient" trigger="hover" [showEvent]="{ name: 'mouseenter' }" [hideEvent]="{ name: 'mouseleave' }">
  <div>Force la vérification de la date de validité de la carte client à la sélection du client.</div>
</dx-popover>